module.exports = __webpack_public_path__ + "static/Giveshop-b5e57c6d095a707ae6f14ce48381c29c.png";